import { useEffect } from "react";
import { useBankForBanksIndication } from "@rshbintech.dboul/access-control";
import { useAppTranslation } from "../use-app-translation";

/**
 * Хук, принудительно устанавливающий русскую локаль для внутреннего контура приложения,
 * так как возможность переключения языка внутри доступна только для клиентов-банков, а смена языка на логине - для всех
 */
export const useDefaultLanguage = () => {
  const { isBankForBanksUser } = useBankForBanksIndication();
  const { changeLanguage, language } = useAppTranslation();

  useEffect(() => {
    if (!isBankForBanksUser && !language.includes("ru")) {
      changeLanguage?.("ru_RU");
    }
  }, []);
};
